import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {HttpCommonService} from "../../services/http-common.service";

import {EnterpAtlasService} from "../../services/enterp-atlas.service";
import '../../../assets/plugins/echarts/dist/echarts2.js';
declare var echartsEC: any;

/**
 * 实际控股人
 */
@Component({
  selector: 'app-enter-actual-control-person',
  templateUrl: './enter-actual-control-person.component.html',
  styleUrls: ['./enter-actual-control-person.component.css']
})
export class EnterActualControlPersonComponent implements OnInit {

  //实际控股人
  myChartKzr: any;
  option: any;
  nodesKzr: any;
  linksKzr: any;
  levels: any;
  //传递的参数 企业ID
  companyId: string;
  constructor(private routerInfo: ActivatedRoute, private httpService: HttpCommonService,
              private enterpAltasService: EnterpAtlasService) {
    this.companyId = routerInfo.snapshot.queryParams['companyId'];
  }

  ngOnInit() {
    this.getKzrData();
  }
  //获取数据
  getKzrData() {
    this.initChart();
    /*this.httpService.get('').subscribe(data => {
      console.info(data);
      this.drawData(data.Result);//处理数据
      this.calcPos(this.myChartKzr);//计算节点
      this.drawKzr(this.nodesKzr,this.linksKzr);//绘画图形
    });*/
    let dataKzr = this.enterpAltasService.getEnterKZR();
    this.drawData(dataKzr.Result);//处理数据
    this.calcPos(this.myChartKzr);//计算节点
    this.drawKzr(this.nodesKzr,this.linksKzr);//绘画图形
  }
  //初始化echarts
  initChart(){
    let thiss = this;
    this.myChartKzr = echartsEC.init(document.getElementById('kzr'));
    /*requireEcharts.config({
      paths: {
        echarts: '../../../assets/plugins/echarts/dist'
      }
    });
    requireEcharts(
      [
        'echarts',
        'echarts/chart/force'
      ],
      function (ec) {
        thiss.myChartKzr = ec.init(document.getElementById('kzr'));
      }
    );*/
  }
  //处理数据
  drawData(root){
    let thiss = this;
    this.nodesKzr = [];
    this.linksKzr = [];
    if (!root.Nodes) {
      root.Nodes = [];
    }
    if (!root.Links) {
      root.Links = [];
    }
    if(root.Nodes.length==0){
      root.Nodes.push({
        CategoryId:root.Category,
        Grade:1,
        KeyNo:root.KeyNo,
        Name:root.Name
      });
      root.Nodes.push({
        CategoryId:2,
        Grade:2,
        KeyNo:'unknow',
        Name:'?'
      });
    }
    if(root.Links.length==0){
      root.Links.push({
        ActualRadio:'?',
        CurrentRadio:'?',
        IsActualController:true,
        Source:'unknow',
        Target:root.KeyNo
      });
    }else if(root.ActualControllerLoopPath && root.ActualControllerLoopPath.length > 0
      && root.ActualControllerLoopPath[root.ActualControllerLoopPath.length-1].Name.length == 0 && root.Nodes.length > 0){
      var grade = root.Nodes[0].Grade+1;
      root.Nodes.unshift({
        "KeyNo": "_?",
        "Name": "?",
        "CategoryId": 2,
        "Grade": grade
      });
      root.Links.push({
        "Source": root.Nodes[0].KeyNo,
        "Target": root.Nodes[1].KeyNo,
        "ActualRadio": "?",
        "CurrentRadio": "?",
        "IsActualController": true
      });
    }
    $.each(root.Nodes,function(i,node){
      var symbolSize = 40;
      var color;
      if(node.Category == 2){
        symbolSize = 25;
      }
      if(node.KeyNo==root.KeyNo){
        color = '#728dc9';
      }else if(node.Category == 1){
        color = '#40bfd5';
      }else if(node.Category == 2){
        color = '#f86c6c';
      }
      thiss.nodesKzr.push({
        name:node.KeyNo,
        keyNo:node.KeyNo,
        level:node.Grade,
        fixX:true,
        fixY:true,
        label:node.Name.replace(/(.{5})(?=.)/g, '$1\n'),
        symbolSize:symbolSize,
        itemStyle:{
          normal: {
            color:color,
          },
        }
      })
    });
    $.each(root.Links,function(i,link){
      for(let i=0;i<thiss.linksKzr.length;i++){
        if(thiss.linksKzr[i].source==link.Source && thiss.linksKzr[i].target==link.Target){
          return;
        }
      }
      let relation = '';
      if(link.CurrentRadio&&link.CurrentRadio!='?'){
        relation = ((link.CurrentRadio.substr(0,link.CurrentRadio.length-1))*10000/10000).toFixed(4)+'%'
      }
      var color = '#ddd';
      var textColor = '#999';
      var textFont = 'normal 12px 微软雅黑';
      if(link.IsActualController){
        color = '#f86c6c';
        textColor = '#f86c6c';
        textFont = 'bolder 15px 微软雅黑';
      }
      thiss.linksKzr.push({
        source : link.Source,
        target : link.Target,
        name : relation,
        weight : 1,
        itemStyle:{
          normal:{
            color:color,
            text:relation,
            textColor:textColor,
            textFont:textFont,
            textPosition:'inside'
          }
        }
      });
    });
  }
  //绘画统计图
  drawKzr(nodesKzr,linksKzr) {
    this.option = {
      tooltip : {
        show:false,
        trigger: 'item',
        formatter: '{b}'
      },
      animation: true,
      series : [
        {
          type:'force',
          name : "股权控制人",
          ribbonType: false,
          linkSymbol:'arrow',
          linkSymbolSize:[10, 10],
          roam: true,
          itemStyle: {
            normal: {
              label: {
                show: true,
                textStyle: {
                  color: '#fff'
                }
              },
              nodeStyle : {
                brushType : 'both',
                borderColor : '#005fac',
                borderWidth : 0
              },
              linkStyle: {
                color: '#ddd'
              }
            },
            emphasis: {
              label: {
                show: false
                // textStyle: null      // 默认使用全局文本样式，详见TEXTSTYLE
              },
              nodeStyle : {
                brushType : 'both',
                borderColor : '#dfdfdf',
                borderWidth : 4
              },
              linkStyle : {

              }
            }
          },
          nodes:nodesKzr,
          links:linksKzr
        }
      ]
    };
    this.myChartKzr.setOption(this.option);
    this.animatieChart(this.myChartKzr,0,0);
    //let ecConfig = require('echarts/config');
    let thiss = this;
    this.myChartKzr.on('restore', function(param){
      thiss.animatieChart(thiss.myChartKzr,0,0);
    });
  }
//计算节点坐标位置
  calcPos(myChartKzr){
    let thiss = this
    this.levels = [];
    $.each(thiss.nodesKzr,function(i,node){
      if(!thiss.levels[node.level]){
        thiss.levels[node.level] = {};
        thiss.levels[node.level].count = 1;
        thiss.levels[node.level].index = 1;
      }else{
        thiss.levels[node.level].count ++;
      }
    });
    let centerX = myChartKzr.getZrender().getWidth()/2;
    let centerY = myChartKzr.getZrender().getHeight()/2;
    let stepY = centerY*1.6/(thiss.levels.length-1);
    stepY = stepY<100?100:stepY;
    var startY = centerY+(this.levels.length-2)*stepY/2-20;
    $.each(thiss.nodesKzr,function(i,node){
      let count = thiss.levels[node.level].count;
      let index = thiss.levels[node.level].index;
      let stepX = centerX*1.2/count-10;
      stepX = stepX<90?90:stepX;
      var startX = centerX - (count-1)*stepX/2;
      node.initial = [startX+(index-1)*stepX,startY-(node.level-1)*stepY];
      thiss.levels[node.level].index++;
    });
  }
  animatieChart(myChart,targetX,targetY){
    let centerX = myChart.getZrender().getWidth()/2;
    let centerY = myChart.getZrender().getHeight()/2;
    let layer = myChart.getZrender().painter._layers[1];
    let animation = myChart.getZrender().animation;
    layer.scale = [0.2,0.2,centerX,centerY];
    layer.rotation = [0,centerX,centerY];
    layer.position = [targetX||0,targetY||0];
    myChart.getZrender().render();
    animation.animate(layer).when(400, {
      scale: [1,1,centerX,centerY]
    }).start('spline').done(function(){
      layer.scale[2] = 0;
      layer.scale[3] = 0;
    }).during(function(){
      myChart.getZrender().render();
    });
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enter-actual-control-person/enter-actual-control-person.component.ts